<template>
  <div>
    <QueryFrame :count="count" :current="page" @handlePage="handlePage"
      @handlePageSize="handlePageSize">
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker class="item" v-model="query.duration" type='daterange' clearable>
            </timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>更新项:</label>
            <lk-select v-model='query.reportUpdateType' class="item" clearable>
              <lk-option v-for="(item,i) in allReportUpdateTypeList" :key="i" :value="i">{{item}}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>创建人:</label>
            <lk-input class="item" v-model.trim="query.createUserName" clearable></lk-input>
          </div>

          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btns">
          <lk-button type='primary' @click="handleBtnsClick('rebuy')" v-if='handlePermission("updatePatientRebuy")'>患者复购</lk-button>
          <lk-button type='primary' @click="handleBtnsClick('report')" v-if='handlePermission("updateReport")'>经营报表</lk-button>
        </div>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
    <!-- <operate-log v-model="showLog" :logList="logData"/> -->
    <lk-modal v-model="rebuyModal" title='患者复购'>
      <div>
        <lk-form ref="rebuyForm" label-position="right" :model="rebuyForm" :rules="rebuyValidate"
          :label-width="134">
          <lk-row>
            <lk-form-item label='商品名称:' prop='goodsName'>
              <goodsSelect v-model="rebuyForm.goodsName"></goodsSelect>
            </lk-form-item>
          </lk-row>
          <lk-row>
            <lk-form-item label='门店类型:' prop='storeType'>
              <lk-select v-model='rebuyForm.storeType' clearable>
                <lk-option v-for="(item,i) in storeTypeList" :key="i" :value='i'>{{item}}
                </lk-option>
              </lk-select>
            </lk-form-item>
          </lk-row>
          <lk-row>
            <lk-form-item label='患者姓名:' prop='patientName'>
              <lk-input v-model='rebuyForm.patientName'></lk-input>
            </lk-form-item>
          </lk-row>

        </lk-form>
      </div>
      <div slot='footer'>
        <lk-button @click='handleClearModal'>取消</lk-button>
        <lk-button type='primary' @click="submit('rebuy')">确定</lk-button>
      </div>
    </lk-modal>
    <lk-modal v-model="reportModal" title='经营报表'>
      <div>
        <lk-form ref="reportForm" label-position="right" :model="reportForm" :rules="reportValidate"
          :label-width="134">
          <lk-row>
            <lk-form-item label='选择报表:' prop='type'>
              <lk-select v-model='reportForm.type'>
                <lk-option v-for="(item,i) in reportTypeList" :key="i" :value="i">{{item}}
                </lk-option>
              </lk-select>
            </lk-form-item>
          </lk-row>
          <lk-row>
            <lk-form-item label='开始时间:' prop='startTime'>
              <timeStampDatePicker :options='disabeOneYear' v-model="reportForm.startTime"
                clearable></timeStampDatePicker>
            </lk-form-item>
          </lk-row>
          <lk-row>
            <lk-form-item label='中止时间:' prop='endTime'>
              <timeStampDatePicker v-model="reportForm.endTime" :options="disabledDateFromToday" clearable></timeStampDatePicker>
            </lk-form-item>
          </lk-row>
          <lk-row>
            <lk-form-item label='选择门店:' prop='storeIdList'>
              <StoreListSelect v-model='reportForm.storeIdList'></StoreListSelect>
            </lk-form-item>
          </lk-row>

        </lk-form>
      </div>
      <div slot='footer'>
        <lk-button @click='handleClearModal'>取消</lk-button>
        <lk-button type='primary' @click="submit('report')">确定</lk-button>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import toolsService from '../../services/tools';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import goodsSelect from '../../components/tools/goodsSelect.vue';

// 接口信息
export default {
  name: 'reportRebuild',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame, goodsSelect,

  },
  computed: {
    storeTypeList() {
      return this.$store.getters.getStoreTypeList;
    },
    reportTypeList() {
      const res = utils.deepClone(this.allReportUpdateTypeList);
      delete res[1];
      return res;
    },
  },
  data() {
    return {
      disableBtns: false,
      allReportUpdateTypeList: {
        1: '患者复购',
        2: '财务进销存报表',
        3: '财务应付暂估明细表',
        4: '进销存万能报表',
        5: '入库退货决策报表',
        6: '零售决策报表',
      },
      query: {


        storeIdList: [],
      },
      showLog: false,
      columns: [

        {
          title: '更新项', key: 'typeName', minWidth: 116, maxWidth: 140,
        },
        {
          title: '创建时间', key: 'createTimeStr', minWidth: 116, maxWidth: 140,
        },
        {
          title: '创建人', key: 'createUserName', minWidth: 116, maxWidth: 140,
        },
        {
          title: '更新状态', key: 'statusStr', minWidth: 116, maxWidth: 140,
        },
        { title: '更新记录', key: 'updateRecord', minWidth: 116 },


      ],
      tableData: [],
      rebuyModal: false,
      rebuyForm: {},
      rebuyValidate: {
        goodsName: [
          { required: true, message: '请选择药品' },
        ],
        storeType: [
          { required: true, message: '请选择门店类型' },
        ],
      },
      reportForm: {
        startTime: null,
        endTime: new Date().getTime() - 24 * 3600 * 1000,
      },
      reportValidate: {
        type: [
          { required: true, message: '请选择报表类型' },
        ],
        startTime: [
          { required: true, message: '请选择开始时间', type: 'number' },
        ],
        endTime: [
          { required: true, message: '请选择结束时间', type: 'number' },
        ],

        storeIdList: [
          { required: true, message: '请选择门店', type: 'array' },
        ],
      },
      reportModal: false,
      submitLoading: false,
      disabeOneYear: {
        disabledDate(date) {
          return (new Date().getTime() - date.getTime()) > 366 * 24 * 3600 * 1000;// 没有考虑闰年
        },
      },
      disabledDateFromToday: {
        disabledDate(date) {
          return (new Date().getTime() - 24 * 3600 * 1000) <= date.getTime();// 没有考虑闰年
        },
      },
    };
  },

  methods: {
    setDisableModal() {
      const nowHour = new Date().getHours();
      console.log(nowHour);
      if (nowHour < 20) {
        this.$Message.error('为保证日常业务运行，请在20：00-24：00系统非繁忙时段操作');
        return true;
      }

      return false;
    },
    submit(type) {
      let target = null;
      let submitFunc = null;
      let params = null;
      // console.log(type);
      if (type === 'rebuy') {
        target = this.$refs.rebuyForm;
        submitFunc = toolsService.updatePatientRebuy;
        params = utils.deepClone(this.rebuyForm);
      } else if (type === 'report') {
        submitFunc = toolsService.updateReport;
        params = utils.deepClone(this.reportForm);
        target = this.$refs.reportForm;
        if (params.startTime > params.endTime) {
          this.$Message.error('请选择正确起始的时间');
          return;
        }
      }
      target.validate((valid) => {
        if (valid) {
          submitFunc(params).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('提交成功');
              this.handleSearch();
            } else {
              this.$Message.error(res.data.error);
            }
            this.handleClearModal();
          }).catch((err) => {
            utils.handleError(err);
            this.handleClearModal();
          });
        }
      });
    },
    handleBtnsClick(name) {
      if (this.setDisableModal()) {
        return;
      }
      if (name === 'rebuy') {
        this.rebuyModal = true;
      } else if (name === 'report') {
        this.reportModal = true;
      }
    },
    handleReset() {
      this.query = {};
    },
    handleClearModal() {
      this.rebuyForm = {};
      this.reportForm = { endTime: new Date().getTime() - 24 * 3600 * 1000 };
      this.$refs.rebuyForm.resetFields();
      this.$refs.reportForm.resetFields();

      this.rebuyModal = false;
      this.reportModal = false;
    },
    getData() {
      const params = utils.deepClone(this.params);
      params.page = this.page;
      params.size = this.size;
      if (params.duration && params.duration.length) {
        [params.startTime, params.endTime] = params.duration;
      }
      toolsService.updateReportList(params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          list.forEach((item) => {
            item.createTimeStr = utils.formatTime(item.createTime); // 创建时间
          });
          this.count = count;
          this.tableData = list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },

  },
  created() {
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
.btns{
  margin-bottom:8px;
  >*{
    margin-right: 8px;
  }
}
</style>
